import { errorPlayerContainerNotCreated } from './errors';
export const playerStop = async (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    await player.stop();
};
